var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "email-detail-page",
    },
    [
      _c("div", { staticClass: "left-panel" }, [
        _c(
          "div",
          { staticClass: "filter-bar" },
          [
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                attrs: { size: "small", placeholder: "排序" },
                on: {
                  change: function ($event) {
                    return _vm.getEmailList(false)
                  },
                },
                model: {
                  value: _vm.filter.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "sort", $$v)
                  },
                  expression: "filter.sort",
                },
              },
              [
                _c("el-option", { attrs: { label: "日期", value: "0" } }),
                _c("el-option", { attrs: { label: "发件人", value: "1" } }),
              ],
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "filter-select",
                attrs: { size: "small", placeholder: "日期" },
                on: {
                  change: function ($event) {
                    return _vm.getEmailList(false)
                  },
                },
                model: {
                  value: _vm.filter.searchDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "searchDate", $$v)
                  },
                  expression: "filter.searchDate",
                },
              },
              [
                _c("el-option", { attrs: { label: "全部", value: "-1" } }),
                _c("el-option", { attrs: { label: "今天", value: "0" } }),
                _c("el-option", { attrs: { label: "昨天", value: "1" } }),
                _c("el-option", { attrs: { label: "一周内", value: "2" } }),
                _c("el-option", { attrs: { label: "上周", value: "3" } }),
                _c("el-option", { attrs: { label: "本月", value: "4" } }),
                _c("el-option", { attrs: { label: "上个月", value: "5" } }),
                _c("el-option", { attrs: { label: "今年", value: "6" } }),
                _c("el-option", { attrs: { label: "往年", value: "7" } }),
              ],
              1
            ),
            _c("el-input", {
              staticClass: "filter-input",
              attrs: {
                size: "small",
                placeholder: "发件人/主题",
                "suffix-icon": "el-icon-search",
              },
              nativeOn: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.getEmailList(false)
                },
              },
              model: {
                value: _vm.filter.keyword,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "keyword", $$v)
                },
                expression: "filter.keyword",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "email-list",
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
              scroll: _vm.handleScroll,
            },
          },
          [
            _vm.isEmpty
              ? _c("el-empty", {
                  staticStyle: { width: "100%" },
                  attrs: { description: "暂无邮件" },
                })
              : _vm._e(),
            _vm._l(_vm.emailList, function (group) {
              return _c(
                "div",
                { key: group.label, staticClass: "email-group" },
                [
                  group.items.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "group-title",
                          on: {
                            click: function ($event) {
                              return _vm.toggleGroup(group)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-arrow-right group-arrow",
                            class: { "is-expanded": group.isExpanded },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(group.label) +
                              "(" +
                              _vm._s(group.items.length) +
                              "条) "
                          ),
                        ]
                      )
                    : _vm._e(),
                  group.items.length > 0
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: group.isExpanded,
                              expression: "group.isExpanded",
                            },
                          ],
                          staticClass: "group-content",
                        },
                        _vm._l(group.items, function (email) {
                          return _c(
                            "div",
                            {
                              key: email.id,
                              staticClass: "email-item",
                              class: {
                                active:
                                  _vm.selectedEmail &&
                                  _vm.selectedEmail.id === email.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectEmail(email)
                                },
                                contextmenu: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showContextMenu($event, email)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "email-item-left" }, [
                                _c("i", {
                                  class: email.isStar
                                    ? "el-icon-star-on"
                                    : "el-icon-star-off",
                                  on: {
                                    click: function ($event) {
                                      return _vm.starEmail(email)
                                    },
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "email-item-right" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-subject",
                                    class: email.isRead ? "isRead" : "",
                                  },
                                  [_vm._v(_vm._s(email.subject))]
                                ),
                                _c("div", { staticClass: "item-row" }, [
                                  _c("span", { staticClass: "item-sender" }, [
                                    _vm._v(
                                      "发件人：" +
                                        _vm._s(
                                          email.sender.name ||
                                            email.sender.address
                                        )
                                    ),
                                  ]),
                                  _c("span", { staticClass: "item-date" }, [
                                    _vm._v(_vm._s(email.receivedDate)),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            }),
            _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoadingMore,
                  expression: "isLoadingMore",
                },
              ],
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "left-footer" },
          [
            _c(
              "el-button",
              {
                staticClass: "compose-btn",
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.openCompose("compose")
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-edit" }), _vm._v(" 写邮件 ")]
            ),
          ],
          1
        ),
      ]),
      _vm.selectedEmail
        ? _c("div", { staticClass: "right-panel" }, [
            _c("div", { staticClass: "detail-header" }, [
              _c("h3", { staticClass: "detail-title" }, [
                _vm._v(_vm._s(_vm.selectedEmail.subject)),
              ]),
              _c(
                "div",
                { staticClass: "detail-actions" },
                [
                  _vm.currentEmail.folderName != "草稿箱" &&
                  _vm.currentEmail.folderName != "已发送"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-chat-dot-square",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openCompose("reply", _vm.selectedEmail)
                            },
                          },
                        },
                        [_vm._v("回复")]
                      )
                    : _vm._e(),
                  _vm.currentEmail.folderName == "草稿箱"
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-position" },
                          on: {
                            click: function ($event) {
                              return _vm.openCompose("draft", _vm.selectedEmail)
                            },
                          },
                        },
                        [_vm._v("发送")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-delete" },
                      on: { click: _vm.deleteEmail },
                    },
                    [_vm._v("删除")]
                  ),
                  _vm.currentEmail.folderName != "草稿箱" &&
                  _vm.currentEmail.folderName != "已发送"
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-position" },
                          on: {
                            click: function ($event) {
                              return _vm.openCompose(
                                "forward",
                                _vm.selectedEmail
                              )
                            },
                          },
                        },
                        [_vm._v("转发")]
                      )
                    : _vm._e(),
                  _vm.currentEmail.folderName != "草稿箱" &&
                  _vm.currentEmail.folderName != "已发送"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-refresh-left",
                          },
                          on: { click: _vm.unRead },
                        },
                        [_vm._v("标为未读")]
                      )
                    : _vm._e(),
                  _vm.currentEmail.folderName != "草稿箱" &&
                  _vm.currentEmail.folderName != "已发送"
                    ? _c(
                        "el-button",
                        {
                          style: _vm.selectedEmail.isStar
                            ? "colir:#f2cb51;"
                            : "",
                          attrs: {
                            size: "small",
                            icon: _vm.selectedEmail.isStar
                              ? "el-icon-star-on"
                              : "el-icon-star-off",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.starEmail(_vm.selectedEmail)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.selectedEmail.isStar ? "取消星标" : "标为星标"
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "detail-info" }, [
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("发件人：")]),
                _c(
                  "span",
                  { staticClass: "info-value" },
                  [
                    _vm.selectedEmail.sender.address !=
                    _vm.selectedEmail.sender.name
                      ? [_vm._v(_vm._s(_vm.selectedEmail.sender.name) + "<")]
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.selectedEmail.sender.address)),
                    _vm.selectedEmail.sender.address !=
                    _vm.selectedEmail.sender.name
                      ? [_vm._v(">")]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("span", { staticClass: "info-label ml-20" }, [
                  _vm._v("发送时间："),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.selectedEmail.receivedDate)),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [_vm._v("收件人：")]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.selectedEmail.recipients
                        .map((e) => e.address)
                        .join("、")
                    )
                  ),
                ]),
              ]),
              _vm.selectedEmail.cc && _vm.selectedEmail.cc.length
                ? _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("抄送："),
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.selectedEmail.cc.map((e) => e.address).join("、")
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.selectedEmail.attachments &&
              _vm.selectedEmail.attachments.length
                ? _c("div", { staticClass: "info-row attachments-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("附件："),
                    ]),
                    _c(
                      "div",
                      { staticClass: "attachment-list" },
                      _vm._l(
                        _vm.selectedEmail.attachments,
                        function (file, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "attachment-tag",
                              on: {
                                click: function ($event) {
                                  return _vm.downLoad(file)
                                },
                              },
                            },
                            [
                              file.fileName.split(".").pop().toLowerCase() ==
                              "pdf"
                                ? _c("svg-icon", {
                                    attrs: {
                                      iconClass: "pdf",
                                      className: "icon",
                                    },
                                  })
                                : file.fileName
                                    .split(".")
                                    .pop()
                                    .toLowerCase() == "xlsx"
                                ? _c("svg-icon", {
                                    attrs: {
                                      iconClass: "xlsx",
                                      className: "icon",
                                    },
                                  })
                                : _c("i", { staticClass: "el-icon-document" }),
                              _c("span", [_vm._v(_vm._s(file.fileName))]),
                              _c("i", { staticClass: "el-icon-download" }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "detail-body" }, [
              _c("div", { staticClass: "detail-content" }, [
                _vm.selectedEmail?.content
                  ? _c("iframe", {
                      ref: "emailFrame",
                      staticClass: "email-frame",
                    })
                  : _vm._e(),
              ]),
              _vm.selectedEmail.inReplyToModels &&
              _vm.selectedEmail.inReplyToModels.length
                ? _c(
                    "div",
                    { staticClass: "detail-inReplyTo-list" },
                    _vm._l(
                      _vm.selectedEmail.inReplyToModels,
                      function (reply, rIdx) {
                        return _c(
                          "div",
                          { key: rIdx, staticClass: "detail-inReplyTo" },
                          [
                            _c(
                              "div",
                              { staticClass: "detail-inReplyTo-header" },
                              [
                                _c("div", [_vm._v(_vm._s(reply.subject))]),
                                _c("div", [
                                  _c(
                                    "div",
                                    [
                                      _vm._v("发件人："),
                                      reply.sender.address != reply.sender.name
                                        ? [
                                            _vm._v(
                                              _vm._s(reply.sender.name) + "<"
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(_vm._s(reply.sender.address)),
                                      reply.sender.address != reply.sender.name
                                        ? [_vm._v(">")]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      "发送时间：" + _vm._s(reply.receivedDate)
                                    ),
                                  ]),
                                ]),
                                _c("div", [
                                  _vm._v(
                                    "收件人：" +
                                      _vm._s(
                                        reply.recipients
                                          .map((e) => e.address)
                                          .join("、")
                                      )
                                  ),
                                ]),
                                reply.cc && reply.cc.length
                                  ? _c("div", [
                                      _vm._v(
                                        "抄送：" +
                                          _vm._s(
                                            reply.cc
                                              .map((e) => e.address)
                                              .join("、")
                                          )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", {
                              staticClass: "detail-inReplyTo-content",
                              domProps: { innerHTML: _vm._s(reply.content) },
                            }),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
            ]),
          ])
        : _c("div", { staticClass: "right-panel empty" }, [
            _c("div", { staticClass: "empty-text" }, [
              _vm._v("请选择邮件查看详情"),
            ]),
          ]),
      _vm.currentEmail.folderName != "草稿箱" &&
      _vm.currentEmail.folderName != "已发送"
        ? _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.contextMenu.visible,
                  expression: "contextMenu.visible",
                },
              ],
              staticClass: "context-menu",
              style: {
                top: _vm.contextMenu.y + "px",
                left: _vm.contextMenu.x + "px",
              },
            },
            [
              _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleMenuAction("reply")
                    },
                  },
                },
                [_vm._v("回复邮件")]
              ),
              _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleMenuAction("forward")
                    },
                  },
                },
                [_vm._v("转发邮件")]
              ),
              _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleMenuAction("unread")
                    },
                  },
                },
                [_vm._v("标为未读")]
              ),
              _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleMenuAction("read")
                    },
                  },
                },
                [_vm._v("标为已读")]
              ),
              _c(
                "li",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleMenuAction("delete")
                    },
                  },
                },
                [_vm._v("删除邮件")]
              ),
              _c("li", { staticClass: "has-sub" }, [
                _vm._v(" 移动至 "),
                _c(
                  "ul",
                  { staticClass: "sub-menu" },
                  _vm._l(_vm.folderList, function (folder) {
                    return _c(
                      "li",
                      {
                        key: folder.id,
                        on: {
                          click: function ($event) {
                            return _vm.handleMenuAction("move", folder.id)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(folder.folderName) + " ")]
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("composeEmailDrawer", {
        attrs: {
          visible: _vm.composeVisible,
          mode: _vm.composeMode,
          email: _vm.composeEmail,
        },
        on: {
          close: function ($event) {
            _vm.composeVisible = false
          },
          sent: _vm.onEmailSent,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }